<template>
  <Card class="graph-card mb-2">
    <div class="graph-body-wrapper">
      <div class="graph-body">
        <div class="hz-bar-data">
          <span
            class="bar-data-left percent-data dashed-border"
            :style="{ width: `${calculateLeftWidth}` + '%' }"
            :title="convertTonumberwithCommas(calculateLeftWidth)"
          >
            <span class="leftBorderData">
              {{ convertTonumberwithCommas(calculateLeftWidth) }}%
            </span>
          </span>
          <span
            class="bar-data-right percent-data"
            :style="{ width: `${calculateRightWidth}` + '%' }"
          >
            <span> {{ convertTonumberwithCommas(calculateRightWidth) }}% </span>
          </span>
        </div>
        <Graph :data="data.estimatedCost" />
        <!-- below bar graph text -->
        <div class="hz-bar-data">
          <span
            class="bar-data-left dashed-border"
            :style="{ width: `${calculateLeftWidth}` + '%' }"
          >
            <span class="leftBorderData">
              <p class="graph-item-left mb-0" style="text-align:right">
                {{ perUserPerMonth[0].title }}
              </p>
              <p class="graph-data mt-2" style="text-align:right">
                ${{ data.totalCvadThreeYear }}
              </p>
            </span>
          </span>

          <span
            class="bar-data-right"
            :style="{ width: `${calculateRightWidth}` + '%' }"
            style="padding-left:25px"
          >
            <p class="graph-item mb-0">
              {{ perUserPerMonth[1].title }}
            </p>
            <p class="graph-data mt-2">
              ${{
                convertTonumberwithCommas(
                  ((data.gcpCost.compute + data.gcpCost.storage) * 3).toFixed(0)
                )
              }}
            </p>
          </span>
        </div>
      </div>
    </div>
    <div class="text-center">
      <hr class="graph-hr" />
      <p class="graph-item">Estimated total cost for 3 years</p>
      <p class="graph-total-cost mt-2">
        ${{
          convertTonumberwithCommas(
            (data.estimatedCost[0] + data.estimatedCost[1]).toFixed(0)
          )
        }}
      </p>
    </div>
  </Card>
</template>

<script>
import Card from '../global/Card.vue';
import Graph from '../global/Graph.vue';

export default {
  name: 'MainGraphCard',
  data() {
    return {
      totalCvadThreeYear: Number,
      estimatedCost: [],
      perUserPerMonth: [
        { id: 'cvad', title: 'Citrix cost', amount: 0 },
        { id: 'gcp', title: 'Google Cloud cost', amount: 0 },
        { id: 'total', title: 'Total cost', amount: 0 },
      ],
    };
  },
  props: {
    data: Object,
  },
  components: {
    Card,
    Graph,
  },
  computed: {
    calculateLeftWidth() {
      let total = this.data.estimatedCost[0] + this.data.estimatedCost[1];
      let left = ((this.data.estimatedCost[0] / total) * 100).toFixed(0);
      return left;
    },

    calculateRightWidth() {
      let total = this.data.estimatedCost[0] + this.data.estimatedCost[1];
      let right = ((this.data.estimatedCost[1] / total) * 100).toFixed(0);
      return right;
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  padding: 0%;
}
.graph-card {
  padding-top: 100px;
  padding-bottom: 100px;
  display: block;
  @media print {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .graph-body-wrapper {
    display: flex;
    justify-content: center;
  }
  .graph-hr {
    width: 70%;
  }
}

.graph-body {
  width: 500px;
}

.hz-bar-data {
  display: flex;
}

.bar-data-left {
  text-align: left;
  padding: 7px;
}

.percent-data {
  font-size: 28px;
}

.dashed-border {
  border-right: 1px dashed;
  position: relative;
}

.bar-data-right {
  padding: 7px;
}

.graph-item {
  font-size: 24px;
  padding-top: 18px;
}
.graph-item-left {
  font-size: 24px;
  padding-top: 18px;
}
.graph-total-cost {
  @extend .graph-data;
  color: $primary;
}
.leftBorderData {
  position: absolute;
  right: 25px;
  width: 200px;
  text-align: right;
}

.leftBorderData .graph-item {
  text-align: end;
}

@media screen and (min-width: 601px) {
  .graph-data {
    font-size: 28px;
    margin-top: 0;
    margin-bottom: 0;
  }
}

@media screen and (max-width: 600px) {
  .graph-body {
    width: 200px;
  }
  .graph-data {
    font-size: 16px;
    margin-top: 0;
    margin-bottom: 0;
  }
  .leftBorderData {
    font-size: 20px;
    position: absolute;
    right: 2px;
  }
  .graph-item {
    font-size: 16px;
  }
  .graph-item-left {
    font-size: 16px;
  }
  .bar-data-right {
    font-size: 20px;
  }
}
</style>
